import formCredentialKeys from './formCredentialKeys';

export default {
  title: 'Api Credential Keys',
  attributeName: 'key',
  getURL: 'key',
  createURL: 'key',
  updateURL: 'key',
  removeURL: '',
  idUpdate:true,
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formCredentialKeys],
  noArea: true,
  goBack: true,
  //autoUpdate: false,
};

